<template>
  <div class="package-list-box">
    <h1 class="title">选择年费会员套餐</h1>
    <div v-if="type === 2" class="view-package">
      <img :src="require('@/assets/img/account/icon_package.png')" alt="" />
      <span>查看不同版本会员套餐内容</span>
      <span class="view-btn" @click="onViewPackage">点击查看</span>
    </div>
    <ul v-if="packageList.length" class="package-list">
      <li v-for="(item, index) in packageList" :key="index" class="package" @click="selectPackage(item)">
        <div :class="['package-top', { excellent: item.packageCode === ANNUITY_TYPE.EXCELLENT }]">
          <div class="info">
            <p>
              <span class="name">{{ item.packageName }}</span>
              <span class="price">
                {{ toThousands((item.packageUnitPrice * item.defaultPackageLimitCode) / 100) }}元/{{
                  item.defaultPackageLimitCode > 1 ? toChinesNum(item.defaultPackageLimitCode) : ''
                }}年
              </span>
            </p>
            <p v-if="item.label" class="label">{{ item.label }}</p>
          </div>
          <p class="desc">{{ item.packageDescription }}</p>
        </div>
        <div :class="['package-content', { selected: item.packageCode === selectedPackageCode }]">
          <h2>{{ item.packageChannelList.length }}个应用渠道</h2>
          <ul class="channel-list">
            <li v-for="(channel, channelIndex) in item.packageChannelList" :key="channelIndex" class="content">
              {{ channel.packageChannelInfo }}{{ item.packageChannelList.length > channelIndex + 1 ? '、' : '' }}
            </li>
          </ul>
          <h2>{{ item.advisoryTypeList.length }}种咨询方式</h2>
          <ul class="advisory-list">
            <li
              v-for="(advisoryType, advisoryTypeIndex) in item.advisoryTypeList"
              :key="advisoryTypeIndex"
              class="content"
            >
              {{ advisoryType.advisoryTypeName }}{{ item.advisoryTypeList.length > advisoryTypeIndex + 1 ? '、' : '' }}
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <div v-if="packageLimitList.length">
      <h1 class="title">选择套餐合约期</h1>
      <ul class="package-limit-list">
        <li
          v-for="(limit, limitIndex) in packageLimitList"
          :key="limitIndex"
          :class="['package-limit', { selected: limit.packageLimitTimeCode === selectedLimitCode }]"
          @click="selectLimit(limit)"
        >
          {{ limit.packageLimitTime }}
        </li>
      </ul>
    </div>

    <el-dialog
      class="service-package-img"
      title="套餐内容"
      :visible.sync="viewPackageDialog"
      show-close
      center
      width="50%"
    >
      <div class="img-box">
        <img :src="require('@/assets/img/account/annual_fee_standard.png')" alt="" />
        <img :src="require('@/assets/img/account/annual_fee_excellent.png')" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { toThousands, toChinesNum } from '@/util/index.js';
import { ANNUITY_TYPE } from '@/lib/constant';

export default {
  name: 'packageConfig',
  props: {
    type: {
      type: Number,
      default: 1 // 1:单体药店，2:连锁药店
    },
    selectedPackageCode: {
      type: [String, Number]
    },
    selectedLimitCode: {
      type: [String, Number]
    },
    packageList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    packageLimitList() {
      const { selectedPackageCode, packageList } = this;
      const currentPackage = packageList.filter(item => {
        return item.packageCode === selectedPackageCode;
      })[0];
      if (currentPackage) return currentPackage.packageLimitList || [];
      return [];
    }
  },
  data() {
    return {
      ANNUITY_TYPE,
      viewPackageDialog: false,
      defaultPackage: 0
    };
  },
  methods: {
    toThousands,
    toChinesNum,
    onViewPackage() {
      this.viewPackageDialog = true;
      Telescope.trackEvent({ trackId: 'zywzpc-click-package-packagedetails' });
    },
    selectPackage(packageInfo) {
      this.$emit('selectPackage', packageInfo);
    },
    selectLimit(limitInfo) {
      this.$emit('selectLimit', limitInfo);
    }
  }
};
</script>

<style lang="scss" scoped>
.package-list-box {
  height: 100%;
  width: 296px;
  margin-left: 16px;
  padding: 16px;
  background: #ffffff;
  .view-package {
    margin: 8px 0 12px 0;
    display: flex;
    align-items: center;
    padding: 16px;
    width: 264px;
    height: 48px;
    background: #ebf8ff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    color: #262626;
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .view-btn {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #1e8dff;
    }
  }
  .title {
    padding: 12px 0;
    font-size: 18px;
    font-weight: 600;
    color: #262626;
  }
  .package-list {
    .package {
      display: flex;
      flex-direction: column;
      margin-bottom: 12px;
      width: 264px;
      border-radius: 8px;
      .package-top {
        padding: 10px 12px 10px;
        color: #8f5a00;
        background: linear-gradient(225deg, #fcd78d 0%, #f4bf55 100%);
        border-radius: 8px 8px 0px 0px;
        &.excellent {
          background: linear-gradient(225deg, #4d4c4a 0%, #2b2b2d 100%);
          color: #f2dcaf;
        }
        .info {
          display: flex;
          font-size: 14px;
          font-weight: 600;
          .price {
            margin: 0 10px;
          }
          .label {
            width: 32px;
            height: 16px;
            line-height: 17px;
            text-align: center;
            background: #df3933;
            border-radius: 8px 8px 8px 0px;
            font-size: 10px;
            color: #ffffff;
          }
        }
        .desc {
          font-size: 10px;
        }
      }
      .package-content {
        flex: 1;
        border-right: 1px solid #ededed;
        border-left: 1px solid #ededed;
        border-bottom: 1px solid #ededed;
        border-radius: 0 0 8px 8px;
        padding: 0 12px 12px;
        &.selected {
          border-right: 1px solid #1e8dff;
          border-left: 1px solid #1e8dff;
          border-bottom: 1px solid #1e8dff;
        }
        h2 {
          padding-top: 12px;
          font-size: 12px;
          font-weight: 500;
          color: #262626;
        }
        .channel-list,
        .advisory-list {
          font-size: 12px;
          color: #595959;
          li {
            display: inline-block;
          }
        }
      }
    }
  }
  .package-limit-list {
    li {
      width: 264px;
      height: 52px;
      line-height: 52px;
      text-align: center;
      margin-bottom: 12px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #efefef;
      &.selected {
        border: 1px solid #1e8dff;
      }
    }
  }
}
/deep/.service-package-img {
  .el-dialog__body {
    padding: 0 24px 24px;
  }
  .img-box {
    display: flex;
    img {
      width: 49%;
      &:first-child {
        margin-right: 2%;
      }
    }
  }
}
/deep/.service-package-img {
  .el-dialog__headerbtn {
    display: block;
  }
}
</style>
